<template>
  <div class="search-analysis">
    <!-- 筛选工具栏 -->
    <div class="sa-toolbar">
      <label>开始日期</label>
      <input v-model="startDate" type="date" />
      <span class="sep">至</span>
      <label>结束日期</label>
      <input v-model="endDate" type="date" />
      <input v-model.trim="keyword" class="kw" type="text" placeholder="筛选关键词" @keyup.enter="load(1)" />
      <button class="btn primary" @click="load(1)">🔍 查询</button>
      <button class="btn" @click="loadLast30">🔄 最近 30 天</button>
      <button class="btn" @click="toggleOrder">↕ {{ orderBy === 'count' ? '按搜索次数' : '按最近搜索' }}</button>
      <button class="btn danger" v-if="isSuper" @click="clearLogs">🧹 清理记录</button>
    </div>

    <div class="scope-tip">📌 统计范围：{{ scopeText }}</div>

    <!-- 汇总卡片 -->
    <div class="sa-grid">
      <div class="card">
        <div class="val">{{ summary.search_count }}</div>
        <div class="lab">搜索总次数</div>
      </div>
      <div class="card">
        <div class="val">{{ summary.keyword_count }}</div>
        <div class="lab">搜索关键词数</div>
      </div>
      <div class="card">
        <div class="val">{{ summary.user_count }}</div>
        <div class="lab">搜索用户数</div>
      </div>
      <div class="card">
        <div class="val warn">{{ summary.no_result_count }}</div>
        <div class="lab">无结果关键词数（可补充商品）</div>
      </div>
    </div>

    <!-- 关键词排行 -->
    <div class="sa-panel">
      <div class="panel-title">🔑 搜索关键词排行</div>
      <table class="sa-table" v-if="list.length > 0">
        <thead>
          <tr>
            <th style="width: 60px">排名</th>
            <th>关键词</th>
            <th style="width: 120px">搜索次数</th>
            <th style="width: 110px">搜索用户数</th>
            <th style="width: 130px">平均命中商品</th>
            <th style="width: 180px">最近搜索时间</th>
            <th style="width: 120px">结果情况</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in list" :key="row.keyword">
            <td>{{ (page - 1) * pageSize + index + 1 }}</td>
            <td class="kw-cell">{{ row.keyword }}</td>
            <td><b>{{ row.search_count }}</b></td>
            <td>{{ row.user_count }}</td>
            <td>{{ row.avg_result }}</td>
            <td>{{ row.last_time }}</td>
            <td>
              <span class="tag" :class="row.has_result ? 'ok' : 'none'">{{ row.has_result ? '有结果' : '无结果' }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="empty">暂无搜索记录</div>

      <div class="sa-footer" v-if="list.length > 0">
        <span class="total-info">共 {{ totalPage || 1 }} 页 / {{ total }} 个关键词</span>
        <div class="pager">
          <button class="btn" :disabled="page <= 1" @click="load(page - 1)">上一页</button>
          <span class="page-num">{{ page }} / {{ totalPage || 1 }}</span>
          <button class="btn" :disabled="page >= totalPage" @click="load(page + 1)">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchAnalyticsApi, clearSearchLogsApi } from '@/api/merchant'

export default {
  name: 'SearchAnalysis',
  data () {
    return {
      startDate: '',
      endDate: '',
      keyword: '',
      orderBy: 'count',
      page: 1,
      pageSize: 20,
      total: 0,
      totalPage: 1,
      list: [],
      summary: {
        search_count: 0,
        keyword_count: 0,
        user_count: 0,
        no_result_count: 0
      },
      scopeText: '',
      isSuper: false
    }
  },
  created () {
    this.loadLast30()
  },
  methods: {
    formatDate (d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    loadLast30 () {
      const now = new Date()
      const start = new Date(now.getTime() - 29 * 24 * 3600 * 1000)
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(now)
      this.load(1)
    },
    toggleOrder () {
      this.orderBy = this.orderBy === 'count' ? 'recent' : 'count'
      this.load(1)
    },
    async load (page) {
      this.page = Math.max(1, page || 1)
      if (!this.startDate || !this.endDate) {
        alert('请选择开始与结束日期')
        return
      }
      try {
        const { data } = await getSearchAnalyticsApi({
          start_date: this.startDate,
          end_date: this.endDate,
          keyword: this.keyword,
          orderBy: this.orderBy,
          page: this.page,
          pageSize: this.pageSize
        })
        this.list = (data && data.list) || []
        this.total = (data && data.total) || 0
        this.totalPage = (data && data.totalPage) || 1
        this.summary = (data && data.summary) || this.summary
        this.scopeText = (data && data.scope) || ''
        this.isSuper = Number(data && data.is_super) === 1
      } catch (e) {
        console.error('搜索分析加载失败', e)
      }
    },
    async clearLogs () {
      if (!confirm('确定清理搜索记录吗？（默认清理全部历史搜索词统计）')) return
      try {
        const { message } = await clearSearchLogsApi(0)
        alert(message || '清理成功')
        this.load(1)
      } catch (e) {
        console.error('清理失败', e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-analysis {
  .sa-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    background: #fff;
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 13px;
    color: #666;

    input { border: 1px solid #e2e2e2; border-radius: 6px; padding: 6px 8px; outline: none; }
    .kw { width: 180px; }
    .sep { color: #bbb; }
  }

  .scope-tip {
    margin: 12px 0;
    font-size: 12px;
    color: #888;
    background: #f7f8fa;
    border-radius: 6px;
    padding: 8px 12px;
  }

  .btn {
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 6px;
    height: 32px;
    padding: 0 14px;
    cursor: pointer;
    color: #666;

    &.primary { background: linear-gradient(90deg, #ff6b35, #ff8c42); color: #fff; border: none; }
    &.danger { border-color: #e53935; color: #e53935; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  .sa-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 14px;
    margin-bottom: 14px;

    .card {
      background: #fff;
      border-radius: 10px;
      padding: 18px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

      .val { font-size: 24px; font-weight: 700; color: #222; &.warn { color: #ff6b35; } }
      .lab { margin-top: 6px; font-size: 12px; color: #999; }
    }
  }

  .sa-panel {
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

    .panel-title { font-weight: 600; margin-bottom: 10px; }
  }

  .sa-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th, td { padding: 9px 8px; border-bottom: 1px solid #f2f2f2; text-align: left; }
    th { color: #888; font-weight: 500; background: #fafafa; }
    .kw-cell { font-weight: 600; color: #222; }

    .tag {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 10px;
      font-size: 12px;

      &.ok { background: #e8f5e9; color: #43a047; }
      &.none { background: #fdecea; color: #e53935; }
    }
  }

  .empty {
    text-align: center;
    color: #bbb;
    padding: 40px 0;
  }

  .sa-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;

    .total-info { font-size: 12px; color: #999; }
    .pager {
      display: flex;
      align-items: center;
      gap: 8px;
      .page-num { font-size: 12px; color: #666; }
    }
  }
}
</style>
